import React, { Component } from 'react'
import BaseTemplate from 'components/templates/BaseTemplate'
import ProfileShow from 'components/organisms/ProfileShow'
import ProfileEdit from 'components/organisms/ProfileEdit'
import { Container } from 'components/qstrap'
import scrollTo from 'utils/ui/scrollTo'

class Profile extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editMode: false,
      sessionExpired: false,
    }

    this.profileBody = this.profileBody.bind(this)
    this.handleEditToogle = this.handleEditToogle.bind(this)
  }

  componentDidUpdate() {
    scrollTo('top')
  }

  handleEditToogle() {
    this.setState({ editMode: !this.state.editMode })
  }

  profileBody() {
    const {
      editMode,
    } = this.state

    return editMode ?
      <ProfileEdit onClickCancel={this.handleEditToogle}/> :
      <ProfileShow onClickEdit={this.handleEditToogle}/>
  }

  render() {
    return (
      <BaseTemplate noBreadcrumb useNewHeader>
        <Container id="Profile" className="p-y-lg">
          {this.profileBody()}
        </Container>
      </BaseTemplate>
    )
  }
}

export default Profile
